import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  startRatingImage,
  photoUserImage,
  whiteArrowImage,
  calendarImage,
  requestsImage,
  chatImage,
  paymentImage,
  aboutImage,
  logoutImage,
  companyProfilePicImage,
  mapIconImage,
  emailIconImaage,
  phoneIconImage,
  editBillingIconImage,
  editIconImage,
  truckImg1Image,
  truckImg2Image,
  addIconImage,
} from "../../assets";
import { Header } from "./components";
import { Link, withRouter } from "react-router-dom";
import { DirectLinkUrl, invokeApi, s3baseUrl } from "../../bl_libs/invokeApi";
import { useSockets } from "../../Context/Context-Sockets/ContextSockets";
import { Badge } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { useSnakbar } from "../../Context/Context-Snakbar/ContextSnackbar";
import { CopyToClipboard, SharePopup } from "../../components";
import ShareIcon from "@material-ui/icons/Share";

const Main = (props) => {
  const { socketOFF, userList, handleRefreshChatList } = useSockets();
  const { showErrorSnak, showSuccessSnak } = useSnakbar();
  const { direct_access_link } = JSON.parse(localStorage.getItem("user"));
  const [foreman, setForeman] = useState(
    JSON.parse(localStorage.getItem("user"))
  );

  const { children } = props;
  const [sideNavActive, setSideNavActive] = useState(false);
  const [active, setActive] = useState(0);

  const [userProfile, setUserProfile] = useState("");

  const handleBadgeDot = () => {
    let message = userList.find((user) => user.unread_messages > 0);

    return message ? false : true;
  };

  let chatDot = handleBadgeDot();

  const logout = () => {
    let requestObj = {
      path: "/app_api/log_out",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      localStorage.clear();
      props.history.push("/login");
      socketOFF();
    });
  };

  const handleClickOnSidebar = (value) => {
    if (window.innerWidth < 769) {
    }
    setSideNavActive(false);
    setActive(value);
  };

  const GetForemanProfile = (type) => {
    let requestObj = {
      path: "/api/sale_team/get_sale_team_profile",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        localStorage.setItem("user", JSON.stringify(res.profile));
      } else {
        //showErrorSnak(res.message);
      }
    });
  };

  useEffect(() => {
    GetForemanProfile();
  }, []);

  useEffect(() => {
    const currentPath = props.history.location.pathname;
    console.log(currentPath);
    if (currentPath.search("/calender") > 0) {
      setActive(1);
    } else if (currentPath.search("/salesman-requests") > 0) {
      setActive(2);
    } else if (currentPath.search("/chats") > 0) {
      setActive(3);
    } else if (currentPath.search("/my-requests") > 0) {
      setActive(4);
    } else if (currentPath.search("/about-us") > 0) {
      setActive(5);
    } else {
      setActive("");
    }
  }, [props.history.location.pathname]);

  useEffect(() => {}, []);

  return (
    <>
      <Header
        sideNavActive={sideNavActive}
        setSideNavActive={setSideNavActive}
        setActive={setActive}
        userProfile={userProfile}
      />

      <div className="wrapper">
        {/* <!-- Sidebar  --> */}
        <nav
          id="sidebar"
          className={
            sideNavActive
              ? "handle-custom-sidebar"
              : "handle-custom-sidebar active"
          }
          style={
            window.innerWidth < 769
              ? {
                  position: "fixed",
                  zIndex: 1000,
                  height: "100vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  paddingTop: 0,
                  marginTop: 0,
                }
              : {}
          }
        >
          <div className="sidebar-top">
            <div className="toggle-menu float-right">
              <button
                type="button"
                id="sidebarCollapse"
                className="btn"
                onClick={() => setSideNavActive(!sideNavActive)}
              >
                <img src={whiteArrowImage} />
              </button>
            </div>
            <div className="clearfix"></div>
            <div className="search-button-wrapper">
              <button
                onClick={() => {
                  props.history.push("/create-request");
                  setActive("");
                }}
                className="custom-btn-small red-btn"
              >
                {sideNavActive ? "Create Request" : "Create"}
              </button>
            </div>
          </div>

          <ul className="list-unstyled components">
            {/* <li className={active === 1 ? "active" : ""}>
              <Link
                to="/salesman/calender"
                onClick={() => handleClickOnSidebar(1)}
              >
                <img src={calendarImage} /> <span>Calendar</span>
              </Link>
            </li> */}

            <li className={active === 4 ? "active" : ""}>
              <Link
                to="/salesman/my-requests"
                onClick={() => handleClickOnSidebar(4)}
              >
                <img src={requestsImage} /> <span>My Requests</span>
              </Link>
            </li>
            <li className={active === 2 ? "active" : ""}>
              <Link
                to="/salesman/salesman-requests"
                onClick={() => handleClickOnSidebar(2)}
              >
                <img src={requestsImage} /> <span> All Requests</span>
              </Link>
            </li>
            {/* <li className={active === 3 ? "active" : ""}>
              <Link
                to="/foreman/chats"
                onClick={() => {
                  handleRefreshChatList();
                  handleClickOnSidebar(3);
                }}
              >
                <Badge
                  style={{ paddingLeft: 0 }}
                  color="primary"
                  variant="dot"
                  invisible={chatDot}
                >
                  <img src={chatImage} />
                </Badge>{" "}
                <span>Chat</span>
              </Link>
            </li> */}
            <li className={active === 5 ? "active" : ""}>
              <Link
                to="/salesman/about-us"
                onClick={() => handleClickOnSidebar(5)}
              >
                <InfoIcon style={{ color: "black" }} /> <span>About Us</span>
              </Link>
            </li>
            {sideNavActive && (
              <>
                <li className="text-center">
                  <button
                    onClick={() => {
                      setSideNavActive(false);
                      props.history.push("/create-request");
                    }}
                    className="custom-btn-small red-btn"
                    style={{ width: 210 }}
                  >
                    Create New Request
                  </button>
                </li>
                <li className="text-center">
                  <CopyToClipboard
                    content={DirectLinkUrl + direct_access_link}
                  />
                </li>
                <li className="text-center">
                  {sideNavActive ? (
                    <button
                      style={{
                        color: "white",
                        outline: "none",
                        width: 210,
                      }}
                      className="custom-btn-small red-btn ml-1 mr-1 mt-2"
                      data-toggle="modal"
                      data-target="#share-link-email"
                    >
                      Share Via Email <ShareIcon className="ml-1" />
                    </button>
                  ) : (
                    ""
                  )}
                </li>
                <li className="text-center">
                  {sideNavActive ? (
                    <button
                      style={{
                        color: "white",
                        outline: "none",
                        width: 210,
                      }}
                      className="custom-btn-small red-btn ml-1 mr-1 mt-2"
                      data-toggle="modal"
                      data-target="#share-link-phone"
                    >
                      Share Via Phone <ShareIcon className="ml-1" />
                    </button>
                  ) : (
                    ""
                  )}
                </li>
              </>
            )}
          </ul>
        </nav>
        {/* <!-- Page Content  --> */}
        {children}
      </div>

      <SharePopup />

      <div
        className="modal fade"
        id="logout"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="logout-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                <h5 className="text-center" id="logout-title">
                  Log out
                </h5>
                <p className="text-center sub-title pb-4 mb-3 pt-40">
                  Are your sure you want to logout?
                </p>
                <div className="row justify-content-center text-center">
                  <div className="col-6">
                    <button
                      onClick={logout}
                      data-dismiss="modal"
                      aria-label="Close"
                      className="custom-btn-small custom-buton float-right"
                    >
                      Yes
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      data-dismiss="modal"
                      aria-label="Close"
                      className="custom-btn-small custom-buton custom-button-pink float-left"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default withRouter(Main);
